import { Routes } from "@angular/router";
import { TeamMemberRoleEnum } from "./enum/team-member-role.enum";
import { authGuard } from "./guards/auth.guard";
import { roleGuard } from "./guards/role.guard";
import { UnauthorizedComponent } from "./components/unauthorized/unauthorized.component";

export const appRoutes: Routes = [
  {
    path: "auth",
    loadChildren: () =>
      import("./modules/auth/auth.routes").then((m) => m.authRoutes),
  },
  {
    path: "unauthorized",
    component: UnauthorizedComponent,
  },
  {
    path: "admin",
    data: {
      breadcrumb: "admin",
      bIcon: "pi pi-users",
      roles: [TeamMemberRoleEnum.SUPER_ADMIN, TeamMemberRoleEnum.ADMIN],
    },
    loadChildren: () =>
      import("./modules/admin/admin.routes").then((m) => m.adminRoutes),
    canActivate: [authGuard, roleGuard],
  },
  {
    path: "project-management",
    data: {
      breadcrumb: "projectManagement",
      bIcon: "pi pi-building",
      roles: [
        TeamMemberRoleEnum.SUPER_ADMIN,
        TeamMemberRoleEnum.ADMIN,
        TeamMemberRoleEnum.PROJECT_MANAGER,
      ],
    },
    loadChildren: () =>
      import("./modules/project-management/project-management.routes").then(
        (m) => m.projectManagementRoutes,
      ),
    canActivate: [authGuard, roleGuard],
  },
  {
    path: "accounting",
    data: {
      breadcrumb: "accounting",
      bIcon: "pi pi-chart-line",
      roles: [
        TeamMemberRoleEnum.SUPER_ADMIN,
        TeamMemberRoleEnum.ADMIN,
        TeamMemberRoleEnum.ACCOUNTANT,
      ],
    },
    loadChildren: () =>
      import("./modules/accounting/accounting.routes").then(
        (m) => m.accountingRoutes,
      ),
    canActivate: [authGuard, roleGuard],
  },
  { path: "", redirectTo: "project-management", pathMatch: "full" },
  { path: "**", redirectTo: "project-management" },
];
